import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function PatientList({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item label="CPF (filtro)" name={[fieldName, 'action', 'data', 'cpf']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
